import {
  dayOfMonthFromIso,
  isoDateTodayLocal,
  validateBaseSchedule,
} from "../../../utils/scheduleTypes";
import type {
  ScheduleRefreshConfig,
  ScheduleRefreshErrors,
} from "./ScheduleRefreshModal.types";

/**
 * Connector schedule-refresh validator: shared base checks (every, repeatOn,
 * refreshHour, timezone) + the incremental-column check unique to this flow.
 */
export const validateScheduleRefresh = (
  config: ScheduleRefreshConfig,
): ScheduleRefreshErrors => {
  const errors: ScheduleRefreshErrors = { ...validateBaseSchedule(config) };

  if (config.incrementalEnabled && !config.incrementalColumn) {
    errors.incrementalColumn = "Select a column";
  }

  if (config.unit === "month") {
    if (!config.startsOn) {
      errors.startsOn = "Pick a start date";
    } else if (config.startsOn < isoDateTodayLocal()) {
      errors.startsOn = "Start date cannot be in the past";
    } else if (dayOfMonthFromIso(config.startsOn) == null) {
      errors.startsOn = "Pick a valid date";
    }
  }

  return errors;
};

export const isScheduleRefreshValid = (
  config: ScheduleRefreshConfig,
): boolean => Object.keys(validateScheduleRefresh(config)).length === 0;
